/**
 * Owner decision 2026-10-01 (two-way SMS retention): messages that open work keeps past the 24-month retention
 * period are listed for admins so they get cleared. Server: sms_retention_held_report() (migration 036; paged by cursor since 037), admins only.
 */
import { supabase } from "./supabase";

export type SmsHoldReason =
  | "open_review"
  | "open_reply_task"
  | "needs_reply"
  | "data_review"
  | "mo_proof_run";

export interface SmsHeldRow {
  inbound_id: number;
  received_at: string;
  age_days: number;
  member_masked: string;
  classification: string | null;
  hold: SmsHoldReason;
  conversation_id: string | null;
  support_task_id: string | null;
  support_task_status: string | null;
  assigned_agent: string | null;
  how_to_clear: string;
}

export interface SmsHeldCursor {
  after_received_at: string;
  after_id: number;
}

export interface SmsHeldReport {
  total: number;
  shown: number;
  rows: SmsHeldRow[];
  /** cursor for the next page; null on the last page (migration 037) */
  next: SmsHeldCursor | null;
  generated_at: string;
}

export const SMS_HOLD_LABEL: Record<SmsHoldReason, string> = {
  open_review: "Consent review not done",
  open_reply_task: "Open reply-reminder task",
  needs_reply: "Unanswered (Needs reply)",
  data_review: "Conversation under data review",
  mo_proof_run: "MO-proof run in progress",
};

export const SMS_HELD_PAGE_SIZE = 100;

export async function getSmsRetentionHeldReport(
  after: SmsHeldCursor | null = null,
  limit = SMS_HELD_PAGE_SIZE,
): Promise<SmsHeldReport> {
  const { data, error } = await supabase.rpc("sms_retention_held_report", {
    p_limit: limit,
    p_after_received_at: after?.after_received_at ?? null,
    p_after_id: after?.after_id ?? null,
  });
  if (error) {
    throw new Error(
      error.code === "42501"
        ? "Only admins can see this report."
        : "The report couldn't load.",
    );
  }
  return data as SmsHeldReport;
}
